import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, Typography, Grid, IconButton } from "@mui/material";
import Header from "components/Header";
import axios from "axios";
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import SubjectIcon from '@mui/icons-material/Subject';
import MessageIcon from '@mui/icons-material/Message';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/system';
import DataGridCustomToolbar from "components/DataGridCustomToolbar";
const StyledCard = styled(Card)({
  borderRadius: '15px',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  transition: '0.3s',
  '&:hover': {
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
  },
});

const StyledButton = styled(Button)({
  backgroundColor: '#ff1744',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#d50000',
  },
  marginTop: '10px',
});

const TalkToUs = () => {
  const [data, setData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  // Fetch data from the API
  const fetchData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/talkus/gettalk`);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Handle delete function
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/talkus/deletetalk/${id}`);
      setData(data.filter(item => item._id !== id));
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="TALK TO US" subtitle="Talk with clients" />
      <Box mt="40px">
        <Grid container spacing={3}>
          {data.map((item) => (
            <Grid item xs={12} md={6} lg={4} key={item._id}>
              <StyledCard>
                <CardContent style={{backgroundColor:"#191f45"}}>
                  <Typography variant="h5" gutterBottom style={{ color: '#3f51b5', fontWeight: 'bold' }}>
                    {item.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" display="flex" alignItems="center" mb={1}>
                    <EmailIcon fontSize="small" style={{ marginRight: '8px' }} /> {item.email}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" display="flex" alignItems="center" mb={1}>
                    <SubjectIcon fontSize="small" style={{ marginRight: '8px' }} /> {item.subject}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" display="flex" alignItems="center" mb={1}>
                  <strong><MessageIcon fontSize="small" style={{ marginRight: '8px' }} /></strong>
                     {item.message}
                  </Typography>
                  <StyledButton
                    variant="contained"
                    startIcon={<DeleteIcon />}
                    onClick={() => handleDelete(item._id)}
                  >
                    Delete
                  </StyledButton>
                </CardContent>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default TalkToUs;
